import { render } from "./org-context-navigator.vue?vue&type=template&id=de779de0&scoped=true"
import script from "./org-context-navigator.vue?vue&type=script&setup=true&lang=js"
export * from "./org-context-navigator.vue?vue&type=script&setup=true&lang=js"

import "./org-context-navigator.vue?vue&type=style&index=0&id=de779de0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de779de0"],['__file',"src/views/context-navigator/org-context-navigator.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "de779de0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('de779de0', __exports__)) {
    api.reload('de779de0', __exports__)
  }
  
  module.hot.accept("./org-context-navigator.vue?vue&type=template&id=de779de0&scoped=true", () => {
    api.rerender('de779de0', render)
  })

}


export default __exports__